<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="content">
<p class="chapterTitle">Contents</p>
<p class="paraNoIndent1A"><a href="#/06_Acknowledgements"><span class="bold">Acknowledgements</span></a></p>
<p class="paraNoIndent1A"><a href="#/07_ch1"><span class="bold">Chapter 1</span> Alarums and Incursions</a></p>
<p class="paraNoIndent1A"><a href="#/16_ch2"><span class="bold">Chapter 2</span> Medieval Murder</a></p>
<p class="paraNoIndent1A"><span href="#/26_ch3" title="Link target outside of Sample"><span class="bold">Chapter 3</span> The Sea Beggars</span></p>
<p class="paraNoIndent1A"><span href="#/33_ch4" title="Link target outside of Sample"><span class="bold">Chapter 4 </span>The Sinking of the <em class="italic">Mary Rose</em></span></p>
<p class="paraNoIndent1A"><span href="#/44_ch5" title="Link target outside of Sample"><span class="bold">Chapter 5</span> Insula Infortunata</span></p>
<p class="paraNoIndent1A"><span href="#/47_ch6" title="Link target outside of Sample"><span class="bold">Chapter 6</span> ‘That Man of Blood’</span></p>
<p class="paraNoIndent1A"><span href="#/59_ch7" title="Link target outside of Sample"><span class="bold">Chapter 7</span> In Search of Michal Morey</span></p>
<p class="paraNoIndent1A"><span href="#/68_ch8" title="Link target outside of Sample"><span class="bold">Chapter 8</span> Tom Boulter the Highwayman</span></p>
<p class="paraNoIndent1A"><span href="#/73_ch9" title="Link target outside of Sample"><span class="bold">Chapter 9</span> The Governor’s Wife or Sir Richard Worse-than-Sly</span></p>
<p class="paraNoIndent1A"><span href="#/77_ch10" title="Link target outside of Sample"><span class="bold">Chapter 10</span> The Loss of the <em class="italic">Royal George</em>.</span></p>
<p class="paraNoIndent1A"><span href="#/80_ch11" title="Link target outside of Sample"><span class="bold">Chapter 11</span> Watching the Wall</span></p>
<p class="paraNoIndent1A"><span href="#/94_ch12" title="Link target outside of Sample"><span class="bold">Chapter 12</span> The Legend of Sophie Dawes</span></p>
<p class="paraNoIndent1A"><span href="#/102_ch13" title="Link target outside of Sample"><span class="bold">Chapter 13</span> ‘For Those in Peril…’</span></p>
<p class="paraNoIndent1A"><span href="#/113_ch14" title="Link target outside of Sample"><span class="bold">Chapter 14</span> ‘Nor Iron Bars a Cage…’</span></p>
<p class="paraNoIndent1A"><span href="#/119_ch15" title="Link target outside of Sample"><span class="bold">Chapter 15</span> Court News</span></p>
<p class="paraNoIndent1A"><span href="#/122_ch16" title="Link target outside of Sample"><span class="bold">Chapter 16 </span>‘Dear Osborne…’</span></p>
<p class="paraNoIndent1A"><span href="#/125_ch17" title="Link target outside of Sample"><span class="bold">Chapter 17 </span>Fifth Column of One</span></p>
<p class="paraNoIndent1A"><span href="#/129_ch18" title="Link target outside of Sample"><span class="bold">Chapter 18</span> ‘Look, Stranger, on This Island Now…’</span></p>
<p class="paraNoIndent1A"><span href="#/132_bibliography" title="Link target outside of Sample"><span class="bold">Bibliography</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_content.vue?ef0b1d4a